/**
 * AES采集SDK Web版本
 */
import AES from './core';
import getRecordingInfo from './xreplay/index';
import { reqIdleCallback } from './utils'; // 是否支持UT，支持UT时断网也直接发送埋点

var SUPPORT_UT = navigator.userAgent.indexOf('WindVane') !== -1; // 离线时的缓存队列

var QUEUE = []; // 离线时最多缓存的埋点条数

var MAX_CACHE_QUEUE = 500; // web环境下走aplus.js发送埋点

var APLUS_LOGKEY = '/aes.1.1'; // web环境下获取基础配置

AES.setConfig(function () {
  var SPM_AB = function () {
    if (window.goldlog && goldlog.spm_ab) {
      return goldlog.spm_ab;
    }

    var siteSPM;
    var spmMeta = document.querySelector('meta[name="spm-id"]') || document.querySelector('meta[name="data-spm"]');

    if (spmMeta) {
      siteSPM = spmMeta.content;

      if (siteSPM && siteSPM.indexOf('.') !== -1) {
        return siteSPM.split('.');
      }
    }

    var pageSPM = document.body && document.body.getAttribute('data-spm');

    if (siteSPM && pageSPM) {
      return [siteSPM, pageSPM];
    }

    return [];
  }();

  var config = {
    // is_top: window.top === window,
    //0 TYPE_NAVIGATE：The page was accessed by following a link, a bookmark, a form submission, a script, or typing the URL in the address bar.
    //1 TYPE_RELOAD：The page was accessed by clicking the Reload button or via the Location.reload() method.
    //2 TYPE_BACK_FORWARD：The page was accessed by navigating into the history.
    //255 TYPE_RESERVED：Any other way.
    // nav_t: window.performance?.navigation?.type,
    // visible: document.hidden !== true,
    // memory: navigator.deviceMemory,
    // cpu: navigator.hardwareConcurrency,
    title: document.title,
    spm_a: SPM_AB[0],
    spm_b: SPM_AB[1],
    hash: location.hash,
    dpi: window.devicePixelRatio,
    sr: "".concat(window.screen.width, "x").concat(window.screen.height)
  }; // meta上的配置覆盖

  var configMeta = document.querySelector('meta[name="aes-config"]');

  if (configMeta) {
    try {
      var configStr = configMeta.getAttribute('content');

      if (configStr) {
        configStr.split('&').forEach(function (item) {
          var kv = item.split('=');
          var k = kv[0];
          var v = decodeURIComponent(kv[1]);

          if (k.indexOf('.') !== -1) {
            var k1 = k.split('.')[0];
            var k2 = k.split('.')[1];

            if (!config[k1]) {
              config[k1] = {};
            }

            config[k1][k2] = v;
          } else {
            config[k] = v;
          }
        });
      }
    } catch (ex) {}
  } // 全局变量配置覆盖


  for (var i in window.AES_CONFIG) {
    config[i] = AES_CONFIG[i];
  }

  return config;
}()); // Hash变化

window.addEventListener('hashchange', function () {
  AES.setConfig('hash', location.hash);
}); // 网络变化

var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

if (connection) {
  var updateNet = function updateNet() {
    // 更新网络状态
    AES.setConfig({
      downlink: connection.downlink,
      net_type: connection.effectiveType
    }); // 联网后发送缓存的埋点

    if (navigator.onLine && QUEUE.length) {
      QUEUE.forEach(function (item) {
        reqIdleCallback(function () {
          AES.send(item);
        });
      });
      QUEUE = [];
    }
  };

  updateNet();
  connection.addEventListener('change', updateNet);
} // title 变化，用Object.defineProperty会导致浏览器的默认行为丢失
// 监听类型不兼容时会报错，所以加try catch
// characterData\subtree：document.querySelector('title').childNodes[0].nodeValue = ''


try {
  var observer = function observer() {
    var title = document.querySelector('title');

    if (!title) {
      return;
    }

    new MutationObserver(function () {
      AES.setConfig('title', document.title);
    }).observe(title, {
      childList: true,
      characterData: true,
      subtree: true
    });
  };

  if (document.querySelector('title')) {
    observer();
  } else {
    document.addEventListener('DOMContentLoaded', observer);
  }
} catch (ex) {} // 可见行
// document.addEventListener('visibilitychange', function(){
//     AES.setConfig('visible', document.hidden !== true)
// })
// XReplay


AES.log = AES.before(AES.log, function () {
  var config; // 更新spm，单页应用下spm可能动态更新

  if (window.goldlog) {
    var spm_ab = goldlog.spm_ab;

    if (spm_ab) {
      if (AES.getConfig('spm_a') !== spm_ab[0]) {
        (config || (config = {}))['spm_a'] = spm_ab[0];
      }

      if (AES.getConfig('spm_b') !== spm_ab[1]) {
        (config || (config = {}))['spm_b'] = spm_ab[1];
      }
    }
  } // 更新xreplay


  var xreplayParams = getRecordingInfo();

  if (xreplayParams) {
    var xreplay_id = xreplayParams.appKey + ',' + xreplayParams.recordingId;

    if (AES.getConfig('xreplay_id') !== xreplay_id) {
      (config || (config = {}))['xreplay_id'] = xreplay_id;
    }
  } // setConfig会进行队列检查，尽可能少执行


  config && AES.setConfig(config);
});
/**
 * 底层的发送埋点逻辑
 * @method AES.send
 * @params dataStr {String} 需要发送的数据
 * @private
 */

AES.send = function (dataStr) {
  var hasAplusJS = window.goldlog && typeof goldlog.record === 'function';

  if (navigator.onLine || SUPPORT_UT && hasAplusJS) {
    var args = [APLUS_LOGKEY, 'EXP', dataStr, !window.AES_DISABLE_POST ? 'POST' : 'GET'];

    if (hasAplusJS) {
      var _goldlog;

      (_goldlog = goldlog).record.apply(_goldlog, args);
    } else {
      // if(!AES.__aplus_url){
      //     let protocol = location.protocol;
      //     AES.__aplus_url = (protocol === 'file:' ? 'http:' : protocol) + '//gm.mmstat.com' + APLUS_LOGKEY + '?';
      // }
      // let img = new Image();
      // img.onload = img.onerror = function () {
      //     img = null;
      // };
      // img.src = AES.__aplus_url + data;
      window.goldlog_queue || (window.goldlog_queue = []);
      goldlog_queue.push({
        action: "goldlog.record",
        arguments: args
      });
    }
  } else {
    // 防止内存溢出
    if (QUEUE.length > MAX_CACHE_QUEUE) {
      QUEUE.shift();
    }

    QUEUE.push(dataStr);
  }
}; // 发送采集脚本加载完成前的埋点
// 之前API拼错了写成了AES_QUENE，兼容老版本


var allQueue = ['AES_QUEUE', 'AES_QUENE'];
allQueue.forEach(function (queue) {
  if (Object.prototype.toString.call(window[queue]) === '[object Array]') {
    window[queue].forEach(function (item) {
      if (typeof item === 'function') {
        item(AES);
      } else {
        AES[item.action].apply(AES, item.arguments);
      }
    });
  } else {
    window[queue] = [];
  }

  window[queue].push = function (item) {
    if (typeof item === 'function') {
      item(AES);
    } else {
      AES[item.action].apply(AES, item.arguments);
    }
  };
});
export default AES;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker@1.0.34@@ali/aes-tracker/es/index.js
// module id = null
// module chunks = 